<template>
  <router-view/>
</template>

<script>

export default {
  name: 'OrdersMain'
}
</script>
